import { render, staticRenderFns } from "./GymDescription.vue?vue&type=template&id=31c57263"
import script from "./GymDescription.vue?vue&type=script&lang=js"
export * from "./GymDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports